import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isCsvUrl',
  standalone: true,
  pure: true
})
export class IsCsvUrlPipe implements PipeTransform {

  transform(url: string): boolean {
    if (!url) {return false;}
    try {
      const pathname = new URL(url).pathname.toLowerCase();
      return pathname.endsWith('.csv');
    } catch {
      return false;
    }
  }
}
